import { Grid } from "@material-ui/core";
import React from "react";
import { DataCard, DataCardDefaultItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { ConflictInterestModel } from "../../domain/ConflictInterestModel";

export const ConflictOfInterest: React.FC<{
  hasConflictOfInterest: boolean,
  conflictOfInterests: ConflictInterestModel[]
}> = ({ hasConflictOfInterest, conflictOfInterests }) => {

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const conflictTypes = [
    {
      "Id": 1,
      "Label": "I am an employee of an Awarding Organisation that is regulated by Ofqual"
    },
    {
      "Id": 2,
      "Label": "I work for an Awarding Organisation as an external consultant or advisor"
    },
    {
      "Id": 3,
      "Label": "I have previously been employed or contracted by an Awarding Organisation"
    },
    {
      "Id": 4,
      "Label": "I have an immediate family member who is employed or contracted by an Awarding Organisation"
    },
    {
      "Id": 5,
      "Label": "I am or have been employed or contracted by an exam board that is not regulated by Ofqual"
    },
    {
      "Id": 6,
      "Label": "Other"
    }
  ]

  const getConflictType = (id: number): string => {
    return conflictTypes.find(conflictType => conflictType.Id === id)!.Label
  }

  const displayConflicts = (conflictOfInterest: ConflictInterestModel) => {
    const items: DataCardDefaultItem[] = [
      {
        itemType: "DEFAULT",
        key: "Name of organisation",
        value: conflictOfInterest.organisationName
      },
      {
        itemType: "DEFAULT",
        key: "Type of conflict",
        value: getConflictType(conflictOfInterest.conflictType),
      },
      {
        itemType: "DEFAULT",
        key: "Details of conflict",
        value: conflictOfInterest.conflictDetail,
      },
      {
        itemType: "DEFAULT",
        key: "Start date",
        value: months[conflictOfInterest.startMonth - 1].concat(" ", conflictOfInterest.startYear.toString())
      },
      {
        itemType: "DEFAULT",
        key: "Is this a current conflict of interest?",
        value: conflictOfInterest.isStillConflict ? "Yes" : "No",
      }
    ]

    if (!conflictOfInterest.isStillConflict) {
      items.push(
        {
          itemType: "DEFAULT",
          key: "End date",
          value: months[conflictOfInterest.endMonth! - 1].concat(" ", conflictOfInterest.endYear!.toString()),
        }
      )
    }

    return items
  }

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataCard
              showHeading={false}
              heading={null}
              items={[
                {
                  itemType: "DEFAULT",
                  key: "Do you have any potential conflicts of interests?",
                  value: hasConflictOfInterest ? "Yes" : "No",
                }
              ]}
              hasAction={false}
              actionDescription={null}
              actionButtonText={null}
              actionFunction={null}
              headingComponent={"h1"}
            />

            {hasConflictOfInterest &&
              (conflictOfInterests.map((conflictOfInterest) => {
                return (
                  <>
                    <br />
                    <DataCard
                      showHeading={false}
                      heading={null}
                      items={displayConflicts(conflictOfInterest)}
                      hasAction={false}
                      actionDescription={null}
                      actionButtonText={null}
                      actionFunction={null}
                      headingComponent={"h1"}
                    />
                  </>
                );
              }))
            }
          </Grid>
        </Grid>
      </div>
    </>
  );
};
